// Lila Widget Engine — Achy Smile
document.addEventListener('DOMContentLoaded', function() {
const ALL_CARDS = { ...window.PRODUCTS, ...window.AFFILIATES };

const launcher   = document.getElementById("lila-launcher");
const panel      = document.getElementById("lila-panel");
const closeBtn   = document.getElementById("closeBtn");
const messagesEl = document.getElementById("messages");
const inputEl    = document.getElementById("userInput");
const sendBtn    = document.getElementById("sendBtn");
const notifDot   = document.getElementById("notifDot");

let isOpen = false;
let hasBooted = false;
let conversationHistory = [];

// ── Open / close ─────────────────────────────────────────────────────────────

function openPanel() {
  isOpen = true;
  panel.classList.add("open");
  launcher.classList.add("open");
  notifDot.style.display = "none";
  positionPanel();
  if (!hasBooted) { const restored = restoreSession(); if (!restored) { hasBooted = true; boot(); } }
  setTimeout(() => inputEl.focus(), 300);
}

function closePanel() {
  isOpen = false;
  panel.classList.remove("open");
  launcher.classList.remove("open");
}

launcher.addEventListener("click", e => {
  if (isDragging) return;
  isOpen ? closePanel() : openPanel();
});

closeBtn.addEventListener("click", closePanel);

// ── Position panel relative to launcher ──────────────────────────────────────

function positionPanel() {
  const lr = launcher.getBoundingClientRect();
  const panelW = Math.min(380, window.innerWidth - 32);
  const panelH = 580;
  const gap = 12;

  let left = lr.left + lr.width / 2 - panelW / 2;
  let bottom = window.innerHeight - lr.top + gap;

  // clamp to viewport
  left = Math.max(16, Math.min(left, window.innerWidth - panelW - 16));
  if (bottom + panelH > window.innerHeight - 16) {
    bottom = window.innerHeight - panelH - 16;
  }

  panel.style.left   = left + "px";
  panel.style.bottom = bottom + "px";
  panel.style.right  = "auto";
  panel.style.width  = panelW + "px";
}

window.addEventListener("resize", () => { if (isOpen) positionPanel(); });

// ── Draggable launcher ────────────────────────────────────────────────────────

let isDragging = false;
let dragStartX, dragStartY, origLeft, origTop;

launcher.addEventListener("mousedown", startDrag);
launcher.addEventListener("touchstart", startDrag, { passive: true });

function startDrag(e) {
  const touch = e.touches ? e.touches[0] : e;
  dragStartX = touch.clientX;
  dragStartY = touch.clientY;
  const rect = launcher.getBoundingClientRect();
  origLeft = rect.left;
  origTop  = rect.top;
  isDragging = false;

  launcher.style.transition = "none";
  launcher.style.right  = "auto";
  launcher.style.bottom = "auto";
  launcher.style.left   = origLeft + "px";
  launcher.style.top    = origTop  + "px";

  document.addEventListener("mousemove", onDrag);
  document.addEventListener("touchmove", onDrag, { passive: false });
  document.addEventListener("mouseup",   endDrag);
  document.addEventListener("touchend",  endDrag);
}

function onDrag(e) {
  const touch = e.touches ? e.touches[0] : e;
  const dx = touch.clientX - dragStartX;
  const dy = touch.clientY - dragStartY;

  if (!isDragging && Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
  isDragging = true;
  if (e.cancelable) e.preventDefault();

  const size = 62;
  let newLeft = origLeft + dx;
  let newTop  = origTop  + dy;

  // clamp to viewport
  newLeft = Math.max(12, Math.min(newLeft, window.innerWidth  - size - 12));
  newTop  = Math.max(12, Math.min(newTop,  window.innerHeight - size - 12));

  launcher.style.left = newLeft + "px";
  launcher.style.top  = newTop  + "px";

  if (isOpen) positionPanel();
}

function endDrag() {
  launcher.style.transition = "";
  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("touchmove", onDrag);
  document.removeEventListener("mouseup",   endDrag);
  document.removeEventListener("touchend",  endDrag);
  setTimeout(() => { isDragging = false; }, 50);
}

// ── Helpers ───────────────────────────────────────────────────────────────────

function scrollToBottom() {
  // Legacy call — scroll to bottom (used for typing indicator only)
  setTimeout(() => { messagesEl.scrollTop = messagesEl.scrollHeight; }, 60);
}

function scrollToEl(el) {
  if (!el) return;
  setTimeout(() => {
    messagesEl.scrollTop = el.offsetTop - 72;
  }, 120);
}

function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

function makeAvatar() {
  // Reuse the same avatar markup as the header
  const headerAvatar = document.getElementById("headerAvatar");
  const clone = headerAvatar.cloneNode(true);
  clone.removeAttribute("id");
  clone.classList.add("msg-avatar");
  clone.style.width  = "26px";
  clone.style.height = "26px";
  clone.style.fontSize = "13px";
  return clone;
}

function addMessage(role, text) {
  const wrap = document.createElement("div");
  wrap.className = `msg ${role}`;
  if (role === "bot") {
    const av = makeAvatar();
    const bubble = document.createElement("div");
    bubble.className = "bubble";
    bubble.innerHTML = text;
    wrap.appendChild(av);
    wrap.appendChild(bubble);
  } else {
    const bubble = document.createElement("div");
    bubble.className = "bubble";
    bubble.textContent = text;
    wrap.appendChild(bubble);
  }
  messagesEl.appendChild(wrap);
  return wrap;
}

function addTyping() {
  const wrap = document.createElement("div");
  wrap.className = "msg bot";
  wrap.id = "typing";
  const av = makeAvatar();
  wrap.innerHTML = "";
  wrap.appendChild(av);
  const t = document.createElement("div");
  t.className = "typing";
  t.innerHTML = "<span></span><span></span><span></span>";
  wrap.appendChild(t);
  messagesEl.appendChild(wrap);
}

function removeTyping() {
  const el = document.getElementById("typing");
  if (el) el.remove();
}

function addChips(chips) {
  if (!chips || !chips.length) return;
  const wrap = document.createElement("div");
  wrap.className = "chips";
  chips.forEach(label => {
    const btn = document.createElement("button");
    btn.className = "chip";
    btn.textContent = label;
    btn.addEventListener("click", () => handleChip(label, wrap));
    wrap.appendChild(btn);
  });
  messagesEl.appendChild(wrap);
  // scroll handled by caller
}

async function fetchShopifyImage(url) {
  try {
    const clean = url.split("?")[0].replace(/\/$/, "");
    let jsonUrl;
    if (clean.includes("/products/")) {
      jsonUrl = clean + ".json";
    } else if (clean.includes("/collections/")) {
      jsonUrl = clean + "/products.json?limit=1";
    } else {
      return null;
    }
    const res = await fetch(jsonUrl);
    if (!res.ok) return null;
    const data = await res.json();
    if (data.product) return data.product.images?.[0]?.src || null;
    if (data.products?.[0]) return data.products[0].images?.[0]?.src || null;
    return null;
  } catch { return null; }
}

function addCard(key) {
  const item = ALL_CARDS[key];
  if (!item) return;
  const el = document.createElement("div");

  const imgId = "img-" + Math.random().toString(36).slice(2);
  const imgHTML = `<img id="${imgId}" class="card-img" style="display:none" alt="${item.name}" loading="lazy"/>`;

  if (item.type === "info") {
    el.className = "info-card";
    const buttons = (item.buttons || []).map(b =>
      `<a class="card-btn" href="${b.url}">${b.label}</a>`
    ).join('');
    el.innerHTML = `
      <div class="card-tag">💜 Support</div>
      <h3>${item.title}</h3>
      <p class="card-desc">${item.body}</p>
      ${buttons}
    `;
    messagesEl.appendChild(el);
    return el;
  } else if (item.type === "affiliate") {
    el.className = "affiliate-card";
    el.innerHTML = `
      ${imgHTML}
      <div class="card-tag">${item.tag}</div>
      <h3>${item.name}</h3>
      <p class="card-desc">${item.desc}</p>
      ${item.deal ? `<div><span class="deal-badge">🎉 ${item.deal}</span></div>` : ""}
      <span class="disclosure">⚠️ ${item.disclosure}</span>
      <a class="affiliate-btn" href="${item.url}" target="_blank" rel="noopener">Visit Partner →</a>
    `;
  } else {
    el.className = "product-card";
    el.innerHTML = `
      ${imgHTML}
      <div class="card-tag">${item.tag}</div>
      <h3>${item.name}</h3>
      <p class="card-desc">${item.desc}</p>
      <a class="card-btn" href="${item.url}">View Product →</a>
    `;
  }

  // Fetch image — el returned below
  messagesEl.appendChild(el);
  // Fetch image asynchronously — card renders immediately, image appears when ready
  fetchShopifyImage(item.url).then(src => {
    if (!src) return;
    const imgEl = el.querySelector(`#${imgId}`);
    if (!imgEl) return;
    imgEl.src = src + "&width=600";
    imgEl.style.display = "block";
  });
  return el;
}

function addBlogCard(blog) {
  if (!blog) return;
  const el = document.createElement("div");
  el.className = "blog-card";

  const featuredLinks = blog.featured && blog.featured.length
    ? `<ul class="blog-links">${blog.featured.map(p =>
        `<li><a href="${p.url}" target="_blank" rel="noopener">→ ${p.title}</a></li>`
      ).join("")}</ul>`
    : "";

  el.innerHTML = `
    <div class="card-tag blog-tag">📖 Achy Smile Blog</div>
    <h3>${blog.label}</h3>
    ${featuredLinks}
    <a class="blog-btn" href="${blog.url}" target="_blank" rel="noopener">Read on the blog →</a>
  `;

  messagesEl.appendChild(el);
}

function disableChips(exceptWrap) {
  document.querySelectorAll(".chips .chip").forEach(c => {
    if (!exceptWrap || c.closest(".chips") !== exceptWrap) {
      c.style.opacity = "0.4";
      c.style.pointerEvents = "none";
    }
  });
}

// ── Flow logic ────────────────────────────────────────────────────────────────

async function handleChip(label, chipWrap) {
  disableChips(chipWrap);
  chipWrap.querySelectorAll(".chip").forEach(c => {
    c.style.pointerEvents = "none";
    if (c.textContent === label) {
      c.style.background = "linear-gradient(135deg,#DCA4FE22,#A788CA22)";
      c.style.borderColor = "#A788CA";
    } else {
      c.style.opacity = "0.35";
    }
  });

  addMessage("user", label);
  conversationHistory.push({ role: "user", content: label });

  const flow = window.FLOWS[label];
  if (flow) {
    addTyping();
    await sleep(flow.delay || 600);
    removeTyping();
    let scrollAnchor = null;
    if (flow.msg) {
      scrollAnchor = addMessage("bot", flow.msg);
      conversationHistory.push({ role: "assistant", content: flow.msg });
    }
    if (flow.product) { const card = addCard(flow.product); if (!scrollAnchor) scrollAnchor = card; }
    if (flow.blog)    addBlogCard(flow.blog);
    if (flow.chips)   addChips(flow.chips);
    if (scrollAnchor) scrollToEl(scrollAnchor);
  } else {
    await handleFreeText(label);
  }
}

async function searchShopify(query) {
  try {
    const res = await fetch(
      `https://achysmile.shop/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=3`
    );
    if (!res.ok) return null;
    const data = await res.json();
    return data?.resources?.results?.products || [];
  } catch { return null; }
}

async function handleFreeText(text) {
  addTyping();
  await sleep(700);
  removeTyping();

  // Check keyword map first (condition-specific routing)
  const lower = text.toLowerCase();
  const match = (window.KEYWORDS || []).find(k =>
    k.keywords.some(kw => lower.includes(kw.toLowerCase()))
  );
  if (match) {
    let kwAnchor = null;
    if (match.msg) kwAnchor = addMessage("bot", match.msg);
    if (match.product) { const c = addCard(match.product); if (!kwAnchor) kwAnchor = c; }
    if (match.chips)   addChips(match.chips);
    if (kwAnchor) scrollToEl(kwAnchor);
    return;
  }

  // Live Shopify product search
  const results = await searchShopify(text);

  if (results === null) {
    // Network error — fall back gracefully
    addMessage("bot", "I had trouble searching right now 💜 Try browsing the shop directly or ask me something else!");
    addChips(["Shop products", "Read the blog", "Start over 🌸"]);
    return;
  }

  if (results.length === 0) {
    addMessage("bot", `I couldn't find anything matching "${text}" in the shop 💜 Want to try browsing a category, or check out the blog?`);
    addChips(["Shop products", "Read the blog", "Start over 🌸"]);
    return;
  }

  // Strong match — show top result as a card + link to full results
  const top = results[0];
  addMessage("bot", `Here's what I found for "${text}" 💜`);

  const el = document.createElement("div");
  el.className = "product-card";
  const imgSrc = top.image?.url || top.featured_image?.url || null;
  el.innerHTML = `
    ${imgSrc ? `<img class="card-img" src="${imgSrc}" alt="${top.title}" loading="lazy"/>` : ""}
    <div class="card-tag">Shop Result</div>
    <h3>${top.title}</h3>
    ${top.body ? `<p class="card-desc">${top.body.replace(/<[^>]*>/g,'').slice(0,100)}…</p>` : ""}
    <a class="card-btn" href="${top.url}">View Product →</a>
  `;
  messagesEl.appendChild(el);

  // If more results, show a "see all" link card
  if (results.length > 1) {
    const more = document.createElement("div");
    more.className = "blog-card";
    more.innerHTML = `
      <div class="card-tag" style="color:var(--purple)">🔍 More Results</div>
      <ul class="blog-links">
        ${results.slice(1).map(p => `<li><a href="${p.url}" target="_blank" rel="noopener">→ ${p.title}</a></li>`).join("")}
      </ul>
      <a class="blog-btn" href="https://achysmile.shop/search?q=${encodeURIComponent(text)}&type=product" target="_blank" rel="noopener">See all results →</a>
    `;
    messagesEl.appendChild(more);
  }

  addChips(["Search something else", "Start over 🌸"]);
}

// ── Boot ──────────────────────────────────────────────────────────────────────


// ── Session persistence ───────────────────────────────────────────────────────
function saveSession() {
  try {
    sessionStorage.setItem('lila_html', messagesEl.innerHTML);
    sessionStorage.setItem('lila_open', isOpen ? '1' : '0');
  } catch(e) {}
}

function restoreSession() {
  try {
    const html = sessionStorage.getItem('lila_html');
    const open = sessionStorage.getItem('lila_open');
    if (html) {
      messagesEl.innerHTML = html;
      hasBooted = true;
      // Re-disable all old chips except last set
      const allChipWraps = messagesEl.querySelectorAll('.chips');
      allChipWraps.forEach((wrap, i) => {
        if (i < allChipWraps.length - 1) {
          wrap.querySelectorAll('.chip').forEach(c => {
            c.style.opacity = '0.4';
            c.style.pointerEvents = 'none';
          });
        }
      });
      scrollToBottom();
    }
    if (open === '1') {
      isOpen = true;
      panel.classList.add('open');
      launcher.classList.add('open');
      notifDot.style.display = 'none';
    }
    return !!html;
  } catch(e) { return false; }
}

async function boot() {
  await sleep(400);
  addTyping();
  await sleep(900);
  removeTyping();
  const { msg, chips } = window.FLOWS.start;
  addMessage("bot", msg);
  conversationHistory.push({ role: "assistant", content: msg });
  addChips(chips);
}

// ── Send handler ──────────────────────────────────────────────────────────────

async function handleSend() {
  const text = inputEl.value.trim();
  if (!text) return;
  inputEl.value = "";
  inputEl.style.height = "auto";
  disableChips(null);
  addMessage("user", text);
  conversationHistory.push({ role: "user", content: text });
  await handleFreeText(text);
}

sendBtn.addEventListener("click", handleSend);
inputEl.addEventListener("keydown", e => {
  if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend(); }
});
inputEl.addEventListener("input", function() {
  this.style.height = "auto";
  this.style.height = Math.min(this.scrollHeight, 90) + "px";
});

// ── Special chip routing ──────────────────────────────────────────────────────
// ONLY handles chips whose display label differs from their FLOWS key,
// or "Start over" which needs a full reset instead of a flow lookup.
// All other chips are handled by their own addEventListener in addChips().

const CHIP_REMAPS = {
  "Find a headache specialist": "I need help finding a specialist",
};

document.addEventListener("click", e => {
  if (!e.target.classList.contains("chip")) return;
  const label = e.target.textContent;
  const chipWrap = e.target.closest(".chips");

  if (label === "Start over 🌸") {
    e.stopImmediatePropagation();
    messagesEl.innerHTML = "";
    conversationHistory = [];
    boot();
    return;
  }

  if (CHIP_REMAPS[label]) {
    e.stopImmediatePropagation();
    handleChip(CHIP_REMAPS[label], chipWrap);
  }
});

// Show notif dot after 3 seconds to draw attention
setTimeout(() => {
  if (!isOpen) notifDot.style.display = "block";
}, 3000);

});
